/**
 * Allinpay CNP Checkout Bridge - Shopify Theme Asset JS
 * shop.nicara.ai — Alipay / WeChat branded shells, Zapry & JSAPI support.
 *
 * Canonical source — deploy as allinpay-bridge-v3.js for CDN cache bust.
 */
(function () {
  'use strict'

  var I18N = {
    en: {
      brand: 'Nicara',
      loading: 'Preparing checkout…',
      paymentError: 'Payment Error',
      returnMain: 'Return to Store',
      alipayTitle: 'Alipay Payment',
      redirectAlipay: 'Opening Alipay, please wait…',
      alipayScan: 'Please scan with the Alipay app to complete payment.',
      alipayScanPc: 'Open Alipay on your phone and scan the QR code below.',
      alipayLoadingQr: 'Loading payment QR code…',
      wechatTitle: 'WeChat Pay',
      wechatScan: 'Scan with WeChat to complete payment.',
      wechatScanPc: 'Open WeChat on your phone and scan the QR code below.',
      wechatJsapiTitle: 'WeChat Pay',
      wechatJsapiHint: 'Tap the button below to pay with WeChat.',
      wechatJsapiBtn: 'Pay with WeChat',
      wechatJsapiFail: 'WeChat payment could not be started. Please try again.',
      wechatMobileFallbackTitle: 'Having trouble scanning?',
      wechatMobileStep1: 'Take a screenshot of the QR code',
      wechatMobileStep2: 'Open WeChat → Scan → Album',
      wechatMobileStep3: 'Select the screenshot to pay',
      wechatCopyHint: 'Or copy the link and open it inside WeChat',
      unionpayTitle: 'UnionPay QR Payment',
      unionpayScan: 'Please scan with the UnionPay app to complete payment.',
      redirectTitle: 'Processing Payment',
      redirectHint: 'Please wait while we prepare your payment. This will only take a moment.',
      redirectReturnHint: 'Payment was not completed. You can try again or return to checkout.',
      returnFallbackTitle: 'Unable to return automatically',
      returnFallbackHint: 'Keep this page open. You can retry the status check, continue payment, or return to the store.',
      retryReturn: 'Check payment status',
      continuePayment: 'Continue to Payment',
      invalidForm: 'Invalid FORM_POST payload.',
      invalidQr: 'Invalid QR_CODE payload: missing payUrl.',
      invalidJsapi: 'Invalid JSAPI payload: missing WeChat pay parameters.',
      invalidRedirect: 'Invalid REDIRECT payload: missing payUrl.',
      invalidPayload: 'Invalid or missing payment payload.',
      unsupportedMode: 'Unsupported payment payload mode.',
      orderLabel: 'Order',
      stepPrepare: 'Cart',
      stepBridge: 'Review',
      stepPay: 'Pay',
      stepConfirm: 'Done',
      pollingUnavailable: 'Status polling is unavailable. Please complete payment and return manually.',
      paymentConfirmed: 'Payment confirmed. Returning to your order…',
      waitingConfirm: 'Waiting for payment confirmation…',
      zapryCopyFallback: 'If the payment app does not open, copy this link, open Safari / Chrome, paste it into the address bar, and continue payment there.',
      zapryContinuePayment: 'Continue payment',
      zapryOpenTrying: 'Opening payment page…',
      zapryOpenSucceeded: 'System browser opened. Complete payment there, then return to Zapry.',
      zapryOpenLaunched: 'If nothing happened, use the ··· menu → Open in browser.',
      zapryOpenFallback: 'Could not open automatically. Use the ··· menu → Open in browser.',
      zapryBridgeUnavailable: 'Could not open the system browser. Copy the link below, then paste it into Safari / Chrome to continue payment.',
      zapryBridgeTimeout: 'Zapry did not respond. Copy the link below, then paste it into Safari / Chrome to continue payment.',
      zapryBridgeRateLimited: 'Please wait a moment before trying again.',
      zapryBridgeFailed: 'Could not open the system browser. Copy the link below, then paste it into Safari / Chrome to continue payment.',
      copyLink: 'Copy link',
      copied: 'Copied!',
      copyPayUrl: 'Copy payment link',
      alipayBrand: 'Alipay',
      wechatBrand: 'WeChat Pay',
      foreignCardTitle: 'Visa/JCB Card Payment',
      supportedCardsLabel: 'Supported cards',
      goodsAmountLabel: 'Original payable',
      channelFeeLabel: 'Payment channel fee',
      usdTotalLabel: 'USD total',
      hkdChargeLabel: 'HKD charge',
      fxRateLabel: 'Exchange rate',
      feeNonRefundable: 'The payment channel fee is non-refundable.',
      foreignCardRedirectHint: 'Opening the secure hosted checkout…'
    },
    zh: {
      brand: 'Nicara',
      loading: '正在准备结账…',
      paymentError: '支付出错',
      returnMain: '返回商店',
      alipayTitle: '支付宝支付',
      redirectAlipay: '正在打开支付宝，请稍候…',
      alipayScan: '请使用支付宝 App 扫码完成支付。',
      alipayScanPc: '请使用手机支付宝扫描下方二维码。',
      alipayLoadingQr: '正在加载支付二维码…',
      wechatTitle: '微信支付',
      wechatScan: '请使用微信扫码完成支付。',
      wechatScanPc: '请使用手机微信扫描下方二维码。',
      wechatJsapiTitle: '微信支付',
      wechatJsapiHint: '请点击下方按钮唤起微信支付。',
      wechatJsapiBtn: '立即支付',
      wechatJsapiFail: '无法唤起微信支付，请重试。',
      wechatMobileFallbackTitle: '无法扫码？',
      wechatMobileStep1: '截屏保存下方二维码',
      wechatMobileStep2: '打开微信 → 扫一扫 → 相册',
      wechatMobileStep3: '选择截图完成支付',
      wechatCopyHint: '或复制链接后在微信内打开',
      unionpayTitle: '银联二维码支付',
      unionpayScan: '请使用银联 App 扫码完成支付。',
      redirectTitle: '正在处理支付',
      redirectHint: '请稍候，系统正在为您准备支付页面。',
      redirectReturnHint: '支付尚未完成，您可以重新支付或返回收银台。',
      returnFallbackTitle: '暂时无法自动返回',
      returnFallbackHint: '请保留当前页面，您可以重新查询支付状态、继续支付或返回商店。',
      retryReturn: '查询支付状态',
      continuePayment: '前往支付',
      invalidForm: '支付表单数据无效。',
      invalidQr: '二维码支付数据无效：缺少 payUrl。',
      invalidJsapi: 'JSAPI 支付数据无效：缺少微信支付参数。',
      invalidRedirect: '跳转支付数据无效：缺少 payUrl。',
      invalidPayload: '支付参数无效或缺失。',
      unsupportedMode: '不支持的支付方式。',
      orderLabel: '订单',
      stepPrepare: '购物车',
      stepBridge: '确认订单',
      stepPay: '支付',
      stepConfirm: '完成',
      pollingUnavailable: '暂无法自动查询状态，请完成支付后手动返回。',
      paymentConfirmed: '支付已确认，正在返回订单页面…',
      waitingConfirm: '等待支付确认…',
      zapryCopyFallback: '若未能唤起支付 App，请复制下方链接，打开 Safari / Chrome，粘贴到地址栏访问后继续支付。',
      zapryContinuePayment: '继续支付',
      zapryOpenTrying: '正在打开支付页面…',
      zapryOpenSucceeded: '系统浏览器已打开，请在那里完成支付，然后返回 Zapry。',
      zapryOpenLaunched: '若未跳转，请使用右上角「···」→「在浏览器中打开」',
      zapryOpenFallback: '无法自动打开，请使用右上角「···」→「在浏览器中打开」',
      zapryBridgeUnavailable: '无法打开系统浏览器，请复制下方链接，粘贴到 Safari / Chrome 地址栏后继续支付。',
      zapryBridgeTimeout: 'Zapry 未响应，请复制下方链接，粘贴到 Safari / Chrome 地址栏后继续支付。',
      zapryBridgeRateLimited: '操作过快，请稍后再试。',
      zapryBridgeFailed: '无法打开系统浏览器，请复制下方链接，粘贴到 Safari / Chrome 地址栏后继续支付。',
      copyLink: '复制链接',
      copied: '已复制！',
      copyPayUrl: '复制支付链接',
      alipayBrand: '支付宝',
      wechatBrand: '微信支付',
      foreignCardTitle: 'Visa/JCB 银行卡支付',
      supportedCardsLabel: '支持卡种',
      goodsAmountLabel: '商品应付',
      channelFeeLabel: '支付渠道手续费',
      usdTotalLabel: '美元合计',
      hkdChargeLabel: '港币扣款',
      fxRateLabel: '汇率',
      feeNonRefundable: '支付渠道手续费不予退还。',
      foreignCardRedirectHint: '正在打开安全托管收银台…'
    },
    zh_TW: {
      brand: 'Nicara',
      loading: '正在準備結帳…',
      paymentError: '支付出錯',
      returnMain: '返回商店',
      alipayTitle: '支付寶支付',
      redirectAlipay: '正在開啟支付寶，請稍候…',
      alipayScan: '請使用支付寶 App 掃碼完成支付。',
      alipayScanPc: '請使用手機支付寶掃描下方二維碼。',
      alipayLoadingQr: '正在載入支付二維碼…',
      wechatTitle: '微信支付',
      wechatScan: '請使用微信掃碼完成支付。',
      wechatScanPc: '請使用手機微信掃描下方二維碼。',
      wechatJsapiTitle: '微信支付',
      wechatJsapiHint: '請點擊下方按鈕喚起微信支付。',
      wechatJsapiBtn: '立即支付',
      wechatJsapiFail: '無法喚起微信支付，請重試。',
      wechatMobileFallbackTitle: '無法掃碼？',
      wechatMobileStep1: '截圖保存下方二維碼',
      wechatMobileStep2: '打開微信 → 掃一掃 → 相簿',
      wechatMobileStep3: '選擇截圖完成支付',
      wechatCopyHint: '或複製連結後在微信內打開',
      unionpayTitle: '銀聯二維碼支付',
      unionpayScan: '請使用銀聯 App 掃碼完成支付。',
      redirectTitle: '正在處理支付',
      redirectHint: '請稍候，系統正在為您準備支付頁面。',
      redirectReturnHint: '支付尚未完成，您可以重新支付或返回收銀台。',
      returnFallbackTitle: '暫時無法自動返回',
      returnFallbackHint: '請保留當前頁面，您可以重新查詢支付狀態、繼續支付或返回商店。',
      retryReturn: '查詢支付狀態',
      continuePayment: '前往支付',
      invalidForm: '支付表單資料無效。',
      invalidQr: '二維碼支付資料無效：缺少 payUrl。',
      invalidJsapi: 'JSAPI 支付資料無效：缺少微信支付參數。',
      invalidRedirect: '跳轉支付資料無效：缺少 payUrl。',
      invalidPayload: '支付參數無效或缺失。',
      unsupportedMode: '不支援的支付方式。',
      orderLabel: '訂單',
      stepPrepare: '購物車',
      stepBridge: '確認訂單',
      stepPay: '支付',
      stepConfirm: '完成',
      pollingUnavailable: '暫無法自動查詢狀態，請完成支付後手動返回。',
      paymentConfirmed: '支付已確認，正在返回訂單頁面…',
      waitingConfirm: '等待支付確認…',
      zapryCopyFallback: '若未能喚起支付 App，請複製下方連結，打開 Safari / Chrome，貼到網址列開啟後繼續支付。',
      zapryContinuePayment: '繼續支付',
      zapryOpenTrying: '正在打開支付頁面…',
      zapryOpenSucceeded: '系統瀏覽器已打開，請在那裡完成支付，然後返回 Zapry。',
      zapryOpenLaunched: '若未跳轉，請使用右上角「···」→「在瀏覽器中打開」',
      zapryOpenFallback: '無法自動打開，請使用右上角「···」→「在瀏覽器中打開」',
      zapryBridgeUnavailable: '無法打開系統瀏覽器，請複製下方連結，貼到 Safari / Chrome 網址列後繼續支付。',
      zapryBridgeTimeout: 'Zapry 未響應，請複製下方連結，貼到 Safari / Chrome 網址列後繼續支付。',
      zapryBridgeRateLimited: '操作過快，請稍後再試。',
      zapryBridgeFailed: '無法打開系統瀏覽器，請複製下方連結，貼到 Safari / Chrome 網址列後繼續支付。',
      copyLink: '複製連結',
      copied: '已複製！',
      copyPayUrl: '複製支付連結',
      alipayBrand: '支付寶',
      wechatBrand: '微信支付',
      foreignCardTitle: 'Visa/JCB 銀行卡支付',
      supportedCardsLabel: '支援卡種',
      goodsAmountLabel: '商品應付',
      channelFeeLabel: '支付渠道手續費',
      usdTotalLabel: '美元合計',
      hkdChargeLabel: '港幣扣款',
      fxRateLabel: '匯率',
      feeNonRefundable: '支付渠道手續費不予退還。',
      foreignCardRedirectHint: '正在打開安全託管收銀台…'
    }
  }

  var AllinpayBridge = {
    getLang: function () {
      var params = new URLSearchParams(window.location.search)
      var lang = (params.get('lang') || '').trim()
      if (lang === 'zh_TW' || lang === 'zh-TW' || lang === 'zhTw') return 'zh_TW'
      if (lang === 'zh' || lang === 'zh_CN' || lang === 'zh-CN') return 'zh'
      if (lang === 'en') return 'en'
      var nav = (navigator.language || '').toLowerCase()
      if (nav.indexOf('zh-tw') !== -1 || nav.indexOf('zh-hk') !== -1) return 'zh_TW'
      if (nav.indexOf('zh') !== -1) return 'zh'
      return 'en'
    },

    t: function (key) {
      var lang = this.getLang()
      var dict = I18N[lang] || I18N.en
      return dict[key] || I18N.en[key] || key
    },

    isZapryAppWebView: function () {
      try {
        var ua = String(navigator.userAgent || '')
        if (/\bZapry\/[^\s]+/i.test(ua)) return true
        if (window.isZapry === '1') return true
        if (window.isZapry === true) return true
        if ((window.ZapryJS && typeof window.ZapryJS.callNative === 'function') || window.ZapryJSBridge) return true
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ZapryJS) return true
        if (window.ethereum && window.ethereum.isZapry === true) return true
        if (window.trustwallet && window.trustwallet.isZapry === true) return true
        if (window.zapry && window.zapry.isZapry === true) return true
      } catch (e) {}
      return false
    },

    isIosBrowser: function () {
      try {
        var ua = String(navigator.userAgent || '')
        if (/iPad|iPhone|iPod/i.test(ua)) return true
        return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
      } catch (e) {
        return false
      }
    },

    isAndroidBrowser: function () {
      try {
        return /Android/i.test(String(navigator.userAgent || ''))
      } catch (e) {
        return false
      }
    },

    requiresExternalBrowserPayment: function (payload) {
      if (!this.isZapryAppWebView()) return false
      var channel = this.resolvePayChannel(payload || {})
      if (channel === 'alipay') {
        return this.isIosBrowser() || this.isAndroidBrowser()
      }
      return channel === 'wechat' && this.isIosBrowser()
    },

    shouldRenderZapryExternalBrowserHandoff: function (payload) {
      return this.isZapryAppWebView() &&
        (this.isIosBrowser() ||
          this.isZapryExternalBrowserAvailable() ||
          this.requiresExternalBrowserPayment(payload))
    },

    isZapryExternalBrowserAvailable: function () {
      try {
        return !!(
          window.ZapryBrowserBridge &&
          typeof window.ZapryBrowserBridge.isAvailable === 'function' &&
          window.ZapryBrowserBridge.isAvailable()
        )
      } catch (e) {
        return false
      }
    },

    isBridgeDebugEnabled: function () {
      try {
        var params = new URLSearchParams(window.location.search || '')
        var debugBridge = String(params.get('debugBridge') || '').toLowerCase()
        return debugBridge === '1' || debugBridge === 'true' || debugBridge === 'yes'
      } catch (e) {
        return false
      }
    },

    buildBridgeDebugState: function (payload) {
      payload = payload || {}
      return {
        mode: String(payload.allinpayCnpPayMode || '').toUpperCase(),
        payChannel: this.resolvePayChannel(payload),
        payType: payload.payType,
        isZapryAppWebView: this.isZapryAppWebView(),
        isIosBrowser: this.isIosBrowser(),
        isZapryExternalBrowserAvailable: this.isZapryExternalBrowserAvailable(),
        shouldRenderZapryExternalBrowserHandoff: this.shouldRenderZapryExternalBrowserHandoff(),
        userAgent: String(navigator.userAgent || ''),
        href: String(window.location && window.location.href ? window.location.href : '')
      }
    },

    logBridgeDebugState: function (payload) {
      if (!this.isBridgeDebugEnabled()) return
      try {
        if (console && typeof console.info === 'function') {
          console.info('[AllinpayBridge debug]', this.buildBridgeDebugState(payload))
        }
      } catch (e) {}
    },

    isWechatBrowser: function () {
      try {
        return /MicroMessenger/i.test(String(navigator.userAgent || ''))
      } catch (e) {
        return false
      }
    },

    isDesktop: function () {
      try {
        if (typeof window.matchMedia === 'function') {
          return window.matchMedia('(min-width: 1024px)').matches
        }
      } catch (e) {}
      return (window.innerWidth || 0) >= 1024
    },

    isRepeatGuardedRedirect: function (payload) {
      if (!payload || typeof payload !== 'object') return false
      var mode = String(payload.allinpayCnpPayMode || '').toUpperCase()
      return mode === 'REDIRECT' && this.resolvePayChannel(payload) === 'wechat'
    },

    getRedirectAttemptKey: function (payload) {
      if (!this.isRepeatGuardedRedirect(payload)) return ''
      var id = String(payload.payNo || payload.orderId || payload.payUrl || '').trim()
      return id ? 'allinpay:wechat-redirect-attempted:' + id : ''
    },

    shouldAutoRedirect: function (payload, storage) {
      var key = this.getRedirectAttemptKey(payload)
      if (!key) return true
      try {
        var store = storage || sessionStorage
        return store.getItem(key) !== '1'
      } catch (e) {
        return true
      }
    },

    markRedirectAttempted: function (payload, storage) {
      var key = this.getRedirectAttemptKey(payload)
      if (!key) return
      try {
        var store = storage || sessionStorage
        store.setItem(key, '1')
      } catch (e) {}
    },

    resolveRedirectReturnUrl: function (payload) {
      if (!payload || typeof payload !== 'object') return ''
      return String(payload.cancelReturnUrl || payload.returnUrl || '').trim()
    },

    getRedirectReturnId: function (payload) {
      if (!payload || typeof payload !== 'object') return ''
      return String(payload.payNo || payload.orderId || payload.payUrl || '').trim()
    },

    getRedirectReturnKey: function (payload) {
      var id = this.getRedirectReturnId(payload)
      return id ? 'allinpay:wechat-return:' + id : ''
    },

    getRedirectBridgeKey: function (payload) {
      var id = this.getRedirectReturnId(payload)
      return id ? 'allinpay:wechat-bridge-url:' + id : ''
    },

    persistRedirectReturnUrl: function (payload, storage) {
      if (!this.isRepeatGuardedRedirect(payload)) return
      var key = this.getRedirectReturnKey(payload)
      var returnUrl = this.resolveRedirectReturnUrl(payload)
      if (!key || !returnUrl) return
      try {
        var store = storage || sessionStorage
        store.setItem(key, returnUrl)
      } catch (e) {}
    },

    resolveStoredRedirectReturnUrl: function (payload, storage) {
      var key = this.getRedirectReturnKey(payload)
      if (!key) return ''
      try {
        var store = storage || sessionStorage
        return String(store.getItem(key) || '').trim()
      } catch (e) {
        return ''
      }
    },

    persistRedirectBridgeUrl: function (payload, storage) {
      if (!this.isRepeatGuardedRedirect(payload)) return
      var key = this.getRedirectBridgeKey(payload)
      var bridgeUrl = ''
      try {
        bridgeUrl = String(window.location && window.location.href ? window.location.href : '').trim()
        var parsed = new URL(bridgeUrl)
        if (parsed.origin !== this.resolveBridgeOrigin() || parsed.pathname !== '/pages/allinpay-bridge') return
      } catch (e) {
        return
      }
      try {
        var store = storage || sessionStorage
        store.setItem(key, bridgeUrl)
      } catch (e) {}
    },

    resolveStoredRedirectBridgeUrl: function (payload, storage) {
      var key = this.getRedirectBridgeKey(payload)
      if (!key) return ''
      try {
        var store = storage || sessionStorage
        var bridgeUrl = String(store.getItem(key) || '').trim()
        var parsed = new URL(bridgeUrl)
        return parsed.origin === this.resolveBridgeOrigin() &&
          parsed.pathname === '/pages/allinpay-bridge' ? bridgeUrl : ''
      } catch (e) {
        return ''
      }
    },

    resolveBridgeOrigin: function (options) {
      var origin = String((options && options.origin) || '').trim()
      if (origin) return origin
      try {
        if (window.location && window.location.origin) return window.location.origin
      } catch (e) {}
      return 'https://shop.nicara.ai'
    },

    resolveBridgeReturnUrl: function (payload, options) {
      var id = this.getRedirectReturnId(payload)
      if (!id) return ''
      return this.resolveBridgeOrigin(options) + '/pages/allinpay-bridge-return?payNo=' + encodeURIComponent(id)
    },

    resolveReturnTargetApiBase: function (options) {
      var apiBase = String((options && options.apiBase) || '').trim()
      if (!apiBase) return 'https://api.nicara.ai/api'
      return apiBase.replace(/\/+$/, '')
    },

    getBridgeToken: function () {
      try {
        return String(new URLSearchParams(window.location.search || '').get('allinpayBridgeToken') || '').trim()
      } catch (e) {
        return ''
      }
    },

    getBridgeContextStorageKey: function (token) {
      return 'allinpay:foreign-card-context:' + String(token || '').trim()
    },

    getForeignCardAutoOpenKey: function () {
      var token = this.getBridgeToken()
      return token ? 'allinpay:foreign-card-auto-open:' + token : ''
    },

    getZapryHandoffMode: function () {
      try {
        var mode = String(new URLSearchParams(window.location.search || '').get('zapryHandoff') || '')
        return mode === 'external' || mode === 'inapp' || mode === 'uncertain' ? mode : ''
      } catch (e) {
        return ''
      }
    },

    logBridgeFailure: function (stage, error) {
      try {
        if (typeof console !== 'undefined' && typeof console.error === 'function') {
          console.error('[AllinpayBridge] ' + stage, {
            message: error && error.message ? String(error.message) : 'unknown error'
          })
        }
      } catch (e) {}
    },

    isAllowedAllinpayHostedUrl: function (url) {
      try {
        var parsed = new URL(String(url || ''))
        return parsed.protocol === 'https:' &&
          (parsed.hostname === 'cnp.allinpay.com' || parsed.hostname === 'cnp-test.allinpay.com')
      } catch (e) {
        return false
      }
    },

    validateBridgeContext: function (context) {
      return !!context && Number(context.payType) === 22 && this.isAllowedAllinpayHostedUrl(context.payUrl)
    },

    loadBridgeContext: function (token, options) {
      var normalizedToken = String(token || '').trim()
      if (!normalizedToken) return Promise.reject(new Error('invalid bridge context'))
      var opts = options || {}
      var store = opts.storage || (typeof sessionStorage !== 'undefined' ? sessionStorage : null)
      var storageKey = this.getBridgeContextStorageKey(normalizedToken)
      var cached = null
      try {
        cached = store ? JSON.parse(store.getItem(storageKey) || 'null') : null
      } catch (e) {}
      if (this.validateBridgeContext(cached)) return Promise.resolve(cached)

      var fetchImpl = opts.fetch || (typeof fetch !== 'undefined' ? fetch : null)
      if (!fetchImpl) return Promise.reject(new Error('invalid bridge context'))
      var apiBase = this.resolveReturnTargetApiBase(opts)
      var endpoint = apiBase + '/allinpay-cnp/bridge-context?allinpayBridgeToken=' + encodeURIComponent(normalizedToken)
      var self = this
      return fetchImpl(endpoint, { credentials: 'omit', cache: 'no-store' })
        .then(function (resp) {
          if (!resp || resp.ok === false || typeof resp.json !== 'function') {
            throw new Error('bridge context HTTP error' + (resp && resp.status ? ': ' + resp.status : ''))
          }
          return resp.json()
        })
        .then(function (json) {
          var context = json && json.data ? json.data : json
          if (!self.validateBridgeContext(context)) {
            var responseCode = json && (json.code || json.msg)
            throw new Error('invalid bridge context' + (responseCode ? ': ' + responseCode : ''))
          }
          try {
            if (store) store.setItem(storageKey, JSON.stringify(context))
          } catch (e) {}
          return context
        })
    },

    resolveForeignCardDisplayName: function (context) {
      var displayName = context && context.displayName
      if (typeof displayName === 'string') return displayName.trim() || this.t('foreignCardTitle')
      if (!displayName || typeof displayName !== 'object') return this.t('foreignCardTitle')
      var lang = this.getLang()
      return String(displayName[lang] || displayName.zh_CN || displayName.zh_TW || displayName.en || this.t('foreignCardTitle')).trim()
    },

    formatBridgeAmount: function (amount) {
      var value = Number(amount)
      return Number.isFinite(value) ? value.toFixed(2) : '--'
    },

    renderForeignCardSummary: function (context) {
      var bookCurrency = String(context.bookCurrency || 'USD')
      var gatewayCurrency = String(context.gatewayCurrency || 'HKD')
      var cards = String(context.supportedCards || 'Visa / JCB')
      var rate = String(context.fxRate || '')
      return '<div class="foreign-card-summary">' +
        '<div class="foreign-card-name">' + this.escapeHtml(this.resolveForeignCardDisplayName(context)) + '</div>' +
        '<div class="foreign-card-brands">' + this.escapeHtml(this.t('supportedCardsLabel')) + ': ' + this.escapeHtml(cards) + '</div>' +
        '<div class="foreign-card-row"><span>' + this.escapeHtml(this.t('goodsAmountLabel')) + '</span><strong>' + this.escapeHtml(bookCurrency + ' ' + this.formatBridgeAmount(context.goodsPayAmount)) + '</strong></div>' +
        '<div class="foreign-card-row"><span>' + this.escapeHtml(this.t('channelFeeLabel')) + '</span><strong>' + this.escapeHtml(bookCurrency + ' ' + this.formatBridgeAmount(context.paymentChannelFee)) + '</strong></div>' +
        '<div class="foreign-card-row"><span>' + this.escapeHtml(this.t('usdTotalLabel')) + '</span><strong>' + this.escapeHtml(bookCurrency + ' ' + this.formatBridgeAmount(context.bookAmount)) + '</strong></div>' +
        '<div class="foreign-card-row foreign-card-row--total"><span>' + this.escapeHtml(this.t('hkdChargeLabel')) + '</span><strong>' + this.escapeHtml(gatewayCurrency + ' ' + this.formatBridgeAmount(context.gatewayAmount)) + '</strong></div>' +
        (rate ? '<div class="foreign-card-fx">' + this.escapeHtml(this.t('fxRateLabel')) + ': 1 USD = ' + this.escapeHtml(rate) + ' HKD</div>' : '') +
        '<div class="foreign-card-fee-policy">' + this.escapeHtml(this.t('feeNonRefundable')) + '</div>' +
        '</div>'
    },

    renderForeignCardContext: function (context) {
      if (!this.validateBridgeContext(context)) {
        this.renderError(this.t('invalidPayload'))
        return
      }
      var handoffMode = this.getZapryHandoffMode()
      var needsExternalBrowserHandoff = this.shouldRenderZapryExternalBrowserHandoff(context) &&
        handoffMode !== 'external' &&
        (handoffMode !== 'inapp' || this.requiresExternalBrowserPayment(context))
      var bridgeUrl = String(window.location && window.location.href ? window.location.href : '')
      var self = this
      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: this.resolveForeignCardDisplayName(context),
        channel: 'generic',
        bodyHtml: this.renderForeignCardSummary(context) +
          (needsExternalBrowserHandoff
            ? this.renderZapryCallout()
            : '<div class="hint">' + this.escapeHtml(this.t('foreignCardRedirectHint')) + '</div>' +
              '<div class="actions"><a class="btn" href="' + this.escapeAttr(context.payUrl) + '">' + this.escapeHtml(this.t('continuePayment')) + '</a></div>')
      })
      if (needsExternalBrowserHandoff) {
        this.bindZapryControls(bridgeUrl, context, function () {
          self.replaceLocation(context.payUrl)
          return true
        })
        if (!handoffMode) this.scheduleForeignCardAutoOpen()
        return
      }
      setTimeout(function () { self.replaceLocation(context.payUrl) }, 800)
    },

    resolveMainSiteOrigin: function (url) {
      try {
        var origin = new URL(String(url || '')).origin
        return [
          'https://www.nicara.ai',
          'https://cigarstreet.net',
          'https://www.cigarstreet.net',
          'https://cigar-street.com',
          'https://www.cigar-street.com'
        ].indexOf(origin) !== -1 ? origin : ''
      } catch (e) {
        return ''
      }
    },

    isMainSiteUrl: function (url) {
      return !!this.resolveMainSiteOrigin(url)
    },

    isAllowedMainSiteReturnUrl: function (url) {
      try {
        var parsed = new URL(String(url || ''))
        return !!this.resolveMainSiteOrigin(parsed.href) &&
          parsed.pathname === '/shop/payment-processing' &&
          !!parsed.searchParams.get('payToken')
      } catch (e) {
        return false
      }
    },

    resolveResultReturnUrl: function (url) {
      var normalizedUrl = String(url || '').trim()
      return this.isMainSiteUrl(normalizedUrl)
        ? normalizedUrl
        : 'https://www.nicara.ai'
    },

    resolveRemoteBridgeReturnUrl: function (payload, options) {
      var payNo = this.getRedirectReturnId(payload)
      if (!payNo) return Promise.resolve('')
      var opts = options || {}
      var fetchImpl = opts.fetch || (typeof fetch !== 'undefined' ? fetch : null)
      if (!fetchImpl) return Promise.resolve('')
      var endpoint = this.resolveReturnTargetApiBase(opts) +
        '/allinpay-cnp/return-target?payNo=' + encodeURIComponent(payNo)
      var returnOrigin = this.resolveMainSiteOrigin(this.resolveRedirectReturnUrl(payload))
      if (returnOrigin) endpoint += '&returnOrigin=' + encodeURIComponent(returnOrigin)
      var self = this
      return fetchImpl(endpoint, { credentials: 'omit', cache: 'no-store' })
        .then(function (resp) {
          if (!resp || resp.ok === false || typeof resp.json !== 'function') return null
          return resp.json()
        })
        .then(function (json) {
          var data = json && json.data ? json.data : json
          var redirectUrl = data ? String(data.redirectUrl || '').trim() : ''
          return self.isAllowedMainSiteReturnUrl(redirectUrl) ? redirectUrl : ''
        })
        .catch(function () {
          return ''
        })
    },

    resolveRedirectPayUrl: function (payload) {
      var payUrl = String((payload && payload.payUrl) || '').trim()
      if (!payUrl) return ''
      if (this.resolvePayChannel(payload) !== 'wechat') return payUrl
      var returnUrl = this.resolveBridgeReturnUrl(payload)
      if (!returnUrl) return payUrl
      try {
        var url = new URL(payUrl)
        url.searchParams.set('redirect_url', returnUrl)
        return url.toString()
      } catch (e) {
        var hash = ''
        var hashIndex = payUrl.indexOf('#')
        if (hashIndex !== -1) {
          hash = payUrl.slice(hashIndex)
          payUrl = payUrl.slice(0, hashIndex)
        }
        payUrl = payUrl.replace(/([?&])redirect_url=[^&]*/g, '$1').replace(/[?&]$/, '')
        return payUrl + (payUrl.indexOf('?') === -1 ? '?' : '&') + 'redirect_url=' + encodeURIComponent(returnUrl) + hash
      }
    },

    replaceLocation: function (url) {
      if (!url) return
      if (window.location && typeof window.location.replace === 'function') {
        window.location.replace(url)
        return
      }
      window.location.href = url
    },

    resolvePayChannel: function (payload) {
      if (!payload || typeof payload !== 'object') return 'generic'
      var channel = String(payload.payChannel || '').toLowerCase()
      if (channel === 'alipay' || channel === 'wechat') return channel
      var payType = Number(payload.payType)
      if (payType === 20 || payType === 21) return 'wechat'
      if (payType === 16 || payType === 17) return 'alipay'
      var mode = String(payload.allinpayCnpPayMode || '').toUpperCase()
      if (mode === 'FORM_POST') return 'alipay'
      if (mode === 'JSAPI') return 'wechat'
      return 'generic'
    },

    isAlipayEmbeddedQrMode: function (payload) {
      if (!payload || this.resolvePayChannel(payload) !== 'alipay') return false
      var fields = payload.payFormFields || {}
      var qrMode = fields.qr_pay_mode != null ? String(fields.qr_pay_mode) : ''
      if (qrMode === '4') return true
      var service = String(fields.service || '')
      return service === 'create_forex_trade' && Number(payload.payType) === 16
    },

    buildFormFieldsHtml: function (formFields) {
      var fieldsHtml = ''
      for (var key in formFields) {
        if (formFields.hasOwnProperty(key)) {
          var val = formFields[key]
          if (val == null) continue
          fieldsHtml += '<input type="hidden" name="' + this.escapeAttr(key) + '" value="' + this.escapeAttr(String(val)) + '">\n'
        }
      }
      return fieldsHtml
    },

    getBrandColor: function (channel) {
      if (channel === 'wechat') return '#07C160'
      if (channel === 'alipay') return '#1677FF'
      return '#1677FF'
    },

    renderStepBar: function (activeStep, channel) {
      var brandColor = this.getBrandColor(channel)
      var steps = [
        { id: 1, label: this.t('stepPrepare') },
        { id: 2, label: this.t('stepBridge') },
        { id: 3, label: this.t('stepPay') },
        { id: 4, label: this.t('stepConfirm') }
      ]
      var html = '<div class="journey-steps journey-steps--' + this.escapeAttr(channel) + '" role="list">'
      for (var i = 0; i < steps.length; i++) {
        var step = steps[i]
        var cls = 'journey-step'
        if (step.id < activeStep) cls += ' done'
        if (step.id === activeStep) cls += ' active'
        html += '<div class="' + cls + '" role="listitem" style="--brand:' + brandColor + '">' +
          '<span class="journey-step-dot">' + step.id + '</span>' +
          '<span class="journey-step-label">' + this.escapeHtml(step.label) + '</span>' +
          '</div>'
      }
      html += '</div>'
      return html
    },

    renderOrderSummary: function (orderId, amount, subject, currencySym) {
      var sym = currencySym || 'HK$'
      var amountHtml = amount != null && amount !== ''
        ? '<div class="amount"><span class="sym">' + this.escapeHtml(sym) + '</span>' + this.escapeHtml(String(amount)) + '</div>'
        : '<div class="summary-skeleton"><span class="skeleton-line skeleton-line-lg"></span></div>'
      var subjectHtml = subject
        ? '<div class="goods">' + this.escapeHtml(subject) + '</div>'
        : ''
      var orderHtml = orderId
        ? '<div class="oid">' + this.escapeHtml(this.t('orderLabel')) + ': ' + this.escapeHtml(orderId) + '</div>'
        : ''
      return amountHtml + subjectHtml + orderHtml
    },

    renderPayShellHeader: function (channel) {
      if (channel === 'alipay') {
        return '<div class="pay-shell__header pay-shell__header--alipay">' +
          '<span class="pay-shell__icon pay-shell__icon--alipay" aria-hidden="true">支</span>' +
          '<span class="pay-shell__brand">' + this.escapeHtml(this.t('alipayBrand')) + '</span>' +
          '</div>'
      }
      if (channel === 'wechat') {
        return '<div class="pay-shell__header pay-shell__header--wechat">' +
          '<span class="pay-shell__icon pay-shell__icon--wechat" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M8.5 4C4.9 4 2 6.4 2 9.4c0 1.7 1 3.2 2.5 4.2L4 16l2.9-1.5c.7.2 1.5.3 2.3.3.1 0 .2 0 .3-.1-.2-.6-.3-1.2-.3-1.9 0-3.5 3.4-6.3 7.5-6.3.4 0 .9.1 1.3.1C16.8 5.5 13 4 8.5 4zm-2.3 3.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm4.6 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM22 14.5c0-2.5-2.6-4.5-5.8-4.5S10.4 12 10.4 14.5s2.6 4.5 5.8 4.5c.7 0 1.4-.1 2-.3l2.5 1.3-.7-2.2c1.2-.9 2-2.2 2-3.5zm-7.7-1.3c-.4 0-.8-.3-.8-.8s.3-.8.8-.8.8.3.8.8-.3.8-.8.8zm3.8 0c-.4 0-.8-.3-.8-.8s.3-.8.8-.8.8.3.8.8-.3.8-.8.8z"/></svg>' +
          '</span>' +
          '<span class="pay-shell__brand">' + this.escapeHtml(this.t('wechatBrand')) + '</span>' +
          '</div>'
      }
      return '<div class="logo">' + this.escapeHtml(this.t('brand')) + '</div>'
    },

    wrapCheckoutCard: function (options) {
      var activeStep = options.activeStep || 2
      var title = options.title || this.t('loading')
      var bodyHtml = options.bodyHtml || ''
      var extraHtml = options.extraHtml || ''
      var channel = options.channel || 'generic'
      var layoutSplit = options.layoutSplit === true
      var shellCls = 'pay-shell pay-shell--' + channel
      if (layoutSplit) shellCls += ' pay-shell--layout-split'

      return '<div class="checkout-card journey-card pay-layout">' +
        '<div class="' + shellCls + '">' +
        this.renderPayShellHeader(channel) +
        this.renderStepBar(activeStep, channel) +
        '<div class="pay-shell__body">' +
        '<h3>' + this.escapeHtml(title) + '</h3>' +
        bodyHtml +
        extraHtml +
        '</div></div></div>'
    },

    renderZapryCallout: function () {
      var copyUrl = String(window.location.href || '')
      return '<div class="callout-zapry">' +
        '<div class="callout-zapry-actions">' +
        '<button type="button" id="zapry-continue-payment" class="btn btn--alipay btn-zapry-browser">' +
        this.escapeHtml(this.t('zapryContinuePayment')) + '</button>' +
        '<div id="zapry-continue-payment-feedback" class="callout-zapry-feedback"></div>' +
        '</div>' +
        '<div class="callout-zapry-body">' + this.escapeHtml(this.t('zapryCopyFallback')) + '</div>' +
        this.renderCopyBox('zapry-page-url', copyUrl, 'copy-zapry-link', this.t('copyLink')) +
        '</div>'
    },

    openZapryExternalBrowser: function (url) {
      var targetUrl = String(url || '').trim()
      if (!targetUrl) {
        return Promise.reject({ code: 'INVALID_URL', message: 'Missing external browser URL' })
      }
      if (!this.isZapryExternalBrowserAvailable()) {
        return Promise.reject({
          code: 'BRIDGE_UNAVAILABLE',
          message: 'Zapry external browser bridge is unavailable'
        })
      }
      return window.ZapryBrowserBridge.openExternalBrowser(targetUrl, { timeoutMs: 1500 })
    },

    resolveZapryBridgeErrorMessage: function (error) {
      var code = error && error.code ? String(error.code) : ''
      if (code === 'BRIDGE_UNAVAILABLE') return this.t('zapryBridgeUnavailable')
      if (code === 'NATIVE_TIMEOUT') return this.t('zapryBridgeTimeout')
      if (code === 'RATE_LIMITED') return this.t('zapryBridgeRateLimited')
      return this.t('zapryBridgeFailed')
    },

    bindZapryControls: function (targetUrl, payload, fallbackAction) {
      var self = this
      this.bindCopyButtons()
      var btn = document.getElementById('zapry-continue-payment')
      var feedback = document.getElementById('zapry-continue-payment-feedback')
      if (!btn) return
      btn.addEventListener('click', function () {
        if (btn.disabled) return
        btn.disabled = true
        if (feedback) feedback.textContent = self.t('zapryOpenTrying')
        self.openZapryExternalBrowser(targetUrl)
          .then(function () {
            if (feedback) feedback.textContent = self.t('zapryOpenSucceeded')
            if (payload && payload.statusQueryUrl && !self._zapryPollingStarted) {
              self._zapryPollingStarted = true
              self.startPolling(payload.statusQueryUrl, payload.returnUrl)
            }
            btn.disabled = false
          })
          .catch(function (error) {
            if (typeof fallbackAction === 'function' &&
              !self.requiresExternalBrowserPayment(payload)) {
              try {
                if (fallbackAction(error) !== false) return
              } catch (fallbackError) {
                error = fallbackError
              }
            }
            if (feedback) feedback.textContent = self.resolveZapryBridgeErrorMessage(error)
            btn.disabled = false
          })
      })
    },

    scheduleForeignCardAutoOpen: function (storage) {
      if (!this.isZapryExternalBrowserAvailable()) return false
      var key = this.getForeignCardAutoOpenKey()
      if (!key) return false
      var store = storage || (typeof sessionStorage !== 'undefined' ? sessionStorage : null)
      try {
        if (store && store.getItem(key) === '1') return false
      } catch (e) {}

      var self = this
      setTimeout(function () {
        try {
          if (document.visibilityState && document.visibilityState !== 'visible') return
        } catch (e) {}
        var btn = document.getElementById('zapry-continue-payment')
        if (!btn || typeof btn.click !== 'function') return
        if (self._foreignCardAutoOpenAttemptedKey === key) return
        try {
          if (store && store.getItem(key) === '1') return
          if (store) store.setItem(key, '1')
        } catch (e) {}
        self._foreignCardAutoOpenAttemptedKey = key
        btn.click()
      }, 400)
      return true
    },

    renderCopyBox: function (inputId, value, btnId, btnLabel) {
      return '<div class="pay-url-copy-box">' +
        '<div class="pay-url-copy-row">' +
        '<input id="' + this.escapeAttr(inputId) + '" class="pay-url-copy-input" type="text" readonly value="' + this.escapeAttr(value) + '">' +
        '<button type="button" id="' + this.escapeAttr(btnId) + '" class="btn btn-copy" data-copy-target="' + this.escapeAttr(inputId) + '">' +
        this.escapeHtml(btnLabel) + '</button>' +
        '</div>' +
        '<div class="copy-feedback" id="' + this.escapeAttr(btnId) + '-feedback"></div>' +
        '</div>'
    },

    renderWechatMobileFallback: function (payUrl) {
      var html = '<div class="wechat-fallback">' +
        '<div class="wechat-fallback-title">' + this.escapeHtml(this.t('wechatMobileFallbackTitle')) + '</div>' +
        '<ol class="pay-url-steps">' +
        '<li>' + this.escapeHtml(this.t('wechatMobileStep1')) + '</li>' +
        '<li>' + this.escapeHtml(this.t('wechatMobileStep2')) + '</li>' +
        '<li>' + this.escapeHtml(this.t('wechatMobileStep3')) + '</li>' +
        '</ol>'
      if (payUrl) {
        html += '<div class="wechat-fallback-copy">' + this.escapeHtml(this.t('wechatCopyHint')) + '</div>' +
          this.renderCopyBox('wechat-pay-url', payUrl, 'copy-wechat-pay-url', this.t('copyPayUrl'))
      }
      html += '</div>'
      return html
    },

    bindCopyButtons: function () {
      var self = this
      var buttons = document.querySelectorAll('[data-copy-target]')
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function () {
          var targetId = this.getAttribute('data-copy-target')
          var input = document.getElementById(targetId)
          var feedback = document.getElementById(this.id + '-feedback')
          var text = input ? input.value : ''
          function showCopied () {
            if (feedback) feedback.textContent = self.t('copied')
            this.classList.add('is-copied')
            var btn = this
            setTimeout(function () {
              btn.classList.remove('is-copied')
              if (feedback) feedback.textContent = ''
            }, 2000)
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(showCopied.bind(this)).catch(function () {
              if (input) { input.select(); document.execCommand('copy') }
              showCopied.call(this)
            }.bind(this))
          } else if (input) {
            input.select()
            try { document.execCommand('copy') } catch (e) {}
            showCopied.call(this)
          }
        })
      }
    },

    renderSkeleton: function () {
      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 2,
        title: this.t('loading'),
        bodyHtml:
          '<div class="summary-skeleton">' +
          '<span class="skeleton-line skeleton-line-lg"></span>' +
          '<span class="skeleton-line skeleton-line-md"></span>' +
          '</div>' +
          '<div class="status-box"><div class="spinner brand-spinner"></div></div>'
      })
    },

    decodePayload: function (dataStr) {
      if (!dataStr) {
        var params = new URLSearchParams(window.location.search)
        dataStr = params.get('data') || ''
      }
      if (!dataStr) {
        return null
      }
      try {
        var raw = atob(dataStr)
        var payload = null
        try {
          payload = JSON.parse(raw)
        } catch (ignore) {}
        if (payload && typeof payload === 'object') {
          return payload
        }
        try {
          payload = JSON.parse(decodeURIComponent(raw))
        } catch (ignore) {
          payload = null
        }
        if (payload && typeof payload === 'object') {
          return payload
        }
      } catch (e) {}
      return null
    },

    renderError: function (message) {
      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 2,
        title: this.t('paymentError'),
        bodyHtml:
          '<div class="goods error-text">' + this.escapeHtml(message) + '</div>' +
          '<div class="actions">' +
          '<a class="btn" href="https://www.nicara.ai">' + this.escapeHtml(this.t('returnMain')) + '</a>' +
          '</div>'
      })
    },

    renderFormPost: function (payload) {
      var action = payload.payFormAction || ''
      var charset = payload.payFormCharset || 'UTF-8'
      var formFields = payload.payFormFields || {}
      var orderId = formFields.out_trade_no || payload.payNo || ''
      var amount = formFields.total_fee || payload.amount || '--'
      var subject = formFields.subject || payload.subject || ''
      var channel = this.resolvePayChannel(payload)
      var handoffMode = this.getZapryHandoffMode()
      var needsExternalBrowserHandoff = this.shouldRenderZapryExternalBrowserHandoff(payload) &&
        handoffMode !== 'external' &&
        (handoffMode !== 'inapp' || this.requiresExternalBrowserPayment(payload))

      if (!action || Object.keys(formFields).length === 0) {
        this.renderError(this.t('invalidForm'))
        return
      }

      var fieldsHtml = this.buildFormFieldsHtml(formFields)

      if (needsExternalBrowserHandoff) {
        this.renderAlipayZapryBlocked(
          payload,
          fieldsHtml,
          action,
          charset,
          orderId,
          amount,
          subject,
          channel
        )
        return
      }

      if (this.isAlipayEmbeddedQrMode(payload)) {
        this.renderAlipayEmbeddedQr(payload, fieldsHtml, action, charset, orderId, amount, subject)
        return
      }

      this.renderAlipayRedirectForm(payload, fieldsHtml, action, charset, orderId, amount, subject, channel)
    },

    renderAlipayZapryBlocked: function (payload, fieldsHtml, action, charset, orderId, amount, subject, channel) {
      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: this.t('alipayTitle'),
        channel: channel,
        bodyHtml:
          this.renderOrderSummary(orderId, amount, subject) +
          this.renderZapryCallout(window.location.href)
      }) +
        '<form id="allinpay-form" class="hidden-form" method="post" action="' + this.escapeAttr(action) + '" accept-charset="' + this.escapeAttr(charset) + '">' +
        fieldsHtml +
        '</form>'
      this.bindZapryControls(window.location.href, payload, function () {
        var form = document.getElementById('allinpay-form')
        if (!form || typeof form.submit !== 'function') return false
        form.submit()
        return true
      })
    },

    renderAlipayRedirectForm: function (payload, fieldsHtml, action, charset, orderId, amount, subject, channel) {
      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: this.t('alipayTitle'),
        channel: channel,
        bodyHtml:
          this.renderOrderSummary(orderId, amount, subject) +
          '<div class="status-box">' +
          '<div class="spinner brand-spinner brand-spinner--' + channel + '"></div>' +
          '<div class="hint">' + this.escapeHtml(this.t('redirectAlipay')) + '</div>' +
          '</div>'
      }) +
        '<form id="allinpay-form" class="hidden-form" method="post" action="' + this.escapeAttr(action) + '" accept-charset="' + this.escapeAttr(charset) + '">' +
        fieldsHtml +
        '</form>'

      setTimeout(function () {
        var form = document.getElementById('allinpay-form')
        if (form) form.submit()
      }, 800)
    },

    renderAlipayEmbeddedQr: function (payload, fieldsHtml, action, charset, orderId, amount, subject) {
      var self = this
      var isDesktop = this.isDesktop()
      var formFields = payload.payFormFields || {}
      var qrWidth = parseInt(String(formFields.qrcode_width || (isDesktop ? 240 : 200)), 10)
      if (!qrWidth || qrWidth < 120) qrWidth = isDesktop ? 240 : 200
      var returnUrl = payload.returnUrl || 'https://www.nicara.ai'
      var statusQueryUrl = payload.statusQueryUrl || ''
      var scanHint = isDesktop ? this.t('alipayScanPc') : this.t('alipayScan')

      var qrHost =
        '<div class="alipay-qr-viewport" style="--qr-size:' + qrWidth + 'px">' +
        '<div id="alipay-qr-loading" class="alipay-qr-loading">' +
        '<div class="spinner brand-spinner brand-spinner--alipay"></div>' +
        '<div class="hint">' + this.escapeHtml(this.t('alipayLoadingQr')) + '</div>' +
        '</div>' +
        '<iframe name="alipay-qr-frame" id="alipay-qr-frame" class="alipay-qr-frame is-loading" ' +
        'width="' + qrWidth + '" height="' + qrWidth + '" ' +
        'title="Alipay QR Code" scrolling="no" frameborder="0"></iframe>' +
        '</div>'

      var summaryBlock = this.renderOrderSummary(orderId, amount, subject)
      var statusBlock = '<div id="pay-status" class="hint pay-split__status">' + this.escapeHtml(this.t('waitingConfirm')) + '</div>'
      var actionsBlock =
        '<div class="actions pay-split__actions">' +
        '<a class="btn btn--alipay" href="' + this.escapeAttr(returnUrl) + '">' + this.escapeHtml(this.t('returnMain')) + '</a>' +
        '</div>'
      var scanHintBlock = '<div class="pay-split__scan-hint">' + this.escapeHtml(scanHint) + '</div>'

      var bodyHtml
      if (isDesktop) {
        bodyHtml =
          '<div class="pay-split pay-split--alipay">' +
          '<div class="pay-split__left">' + qrHost + scanHintBlock + '</div>' +
          '<div class="pay-split__right">' + summaryBlock + statusBlock + actionsBlock + '</div>' +
          '</div>'
      } else {
        bodyHtml =
          '<div class="pay-stack pay-stack--alipay">' +
          '<div class="pay-stack__summary">' + summaryBlock + '</div>' +
          '<div class="pay-stack__qr">' + qrHost + scanHintBlock + '</div>' +
          statusBlock + actionsBlock +
          '</div>'
      }

      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: this.t('alipayTitle'),
        channel: 'alipay',
        layoutSplit: isDesktop,
        bodyHtml: bodyHtml
      }) +
        '<form id="allinpay-form" class="hidden-form" method="post" action="' + this.escapeAttr(action) + '" ' +
        'accept-charset="' + this.escapeAttr(charset) + '" target="alipay-qr-frame">' +
        fieldsHtml +
        '</form>'

      var iframe = document.getElementById('alipay-qr-frame')
      var loading = document.getElementById('alipay-qr-loading')
      var formSubmitted = false
      if (iframe) {
        iframe.addEventListener('load', function () {
          if (!formSubmitted) return
          iframe.style.width = qrWidth + 'px'
          iframe.style.height = qrWidth + 'px'
          if (loading) loading.style.display = 'none'
          iframe.classList.remove('is-loading')
        })
      }

      setTimeout(function () {
        var form = document.getElementById('allinpay-form')
        if (form) {
          formSubmitted = true
          form.submit()
        }
      }, 300)

      if (statusQueryUrl) {
        this.startPolling(statusQueryUrl, returnUrl)
      }
    },

    renderQrCode: function (payload) {
      var payUrl = payload.payUrl || ''
      var payNo = payload.payNo || ''
      var orderId = payload.orderId || payNo
      var amount = payload.amount || '--'
      var subject = payload.subject || ''
      var returnUrl = payload.returnUrl || 'https://www.nicara.ai'
      var statusQueryUrl = payload.statusQueryUrl || ''
      var channel = this.resolvePayChannel(payload)
      var isWechat = channel === 'wechat'
      var isDesktop = this.isDesktop()
      var qrSize = isDesktop ? 280 : 200

      if (!payUrl) {
        this.renderError(this.t('invalidQr'))
        return
      }

      var fallbackQrImageUrl = this.buildThirdPartyQrImageUrl(payUrl, qrSize)
      var localQrImageUrl = this.createLocalQrImageUrl(payUrl)
      var qrImageUrl = localQrImageUrl || fallbackQrImageUrl
      var scanHint = isWechat
        ? (isDesktop ? this.t('wechatScanPc') : this.t('wechatScan'))
        : this.t('unionpayScan')
      var title = isWechat ? this.t('wechatTitle') : this.t('unionpayTitle')

      var qrBlock =
        '<div class="qr-wrap qr-wrap--' + channel + '">' +
        '<img id="payment-qr-image" class="qr-image" width="' + qrSize + '" height="' + qrSize + '" ' +
        'src="' + this.escapeAttr(qrImageUrl) + '" data-fallback-src="' + this.escapeAttr(fallbackQrImageUrl) + '" alt="QR Code">' +
        '</div>'

      var summaryBlock = this.renderOrderSummary(orderId, amount, subject)
      var statusBlock = '<div id="pay-status" class="hint">' + this.escapeHtml(scanHint) + '</div>'
      var actionsBlock =
        '<div class="actions">' +
        '<a class="btn btn--' + channel + '" href="' + this.escapeAttr(returnUrl) + '">' + this.escapeHtml(this.t('returnMain')) + '</a>' +
        '</div>'

      var bodyHtml
      if (isDesktop && isWechat) {
        bodyHtml =
          '<div class="pay-split pay-split--wechat">' +
          '<div class="pay-split__left">' + qrBlock + '</div>' +
          '<div class="pay-split__right">' + summaryBlock + statusBlock + actionsBlock + '</div>' +
          '</div>'
      } else if (isWechat) {
        bodyHtml =
          '<div class="pay-stack pay-stack--wechat">' +
          '<div class="pay-stack__summary">' + summaryBlock + '</div>' +
          '<div class="pay-stack__qr">' + qrBlock +
          '<div class="pay-stack__scan-hint">' + this.escapeHtml(scanHint) + '</div></div>' +
          statusBlock + actionsBlock +
          '</div>'
        if (!isDesktop && !this.isWechatBrowser()) {
          bodyHtml += this.renderWechatMobileFallback(payUrl)
        }
      } else {
        bodyHtml = summaryBlock + qrBlock + statusBlock + actionsBlock
      }

      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: title,
        channel: channel,
        layoutSplit: isDesktop && isWechat,
        bodyHtml: bodyHtml
      })

      this.bindQrImageFallback()

      if (isWechat && !isDesktop && !this.isWechatBrowser()) {
        this.bindCopyButtons()
      }

      if (statusQueryUrl) {
        this.startPolling(statusQueryUrl, returnUrl)
      } else {
        var statusEl = document.getElementById('pay-status')
        if (statusEl) {
          statusEl.textContent = this.t('pollingUnavailable')
        }
      }
    },

    buildThirdPartyQrImageUrl: function (payUrl, qrSize) {
      return 'https://api.qrserver.com/v1/create-qr-code/?size=' + qrSize + 'x' + qrSize +
        '&margin=10&data=' + encodeURIComponent(String(payUrl || ''))
    },

    createLocalQrImageUrl: function (payUrl) {
      try {
        var qrFactory = window && window.qrcode
        if (typeof qrFactory !== 'function') return ''
        var previousStringToBytes = qrFactory.stringToBytes
        var utf8Encoder = qrFactory.stringToBytesFuncs && qrFactory.stringToBytesFuncs['UTF-8']
        if (utf8Encoder) qrFactory.stringToBytes = utf8Encoder
        try {
          var qr = qrFactory(0, 'M')
          qr.addData(String(payUrl || ''), 'Byte')
          qr.make()
          return String(qr.createDataURL(4, 16) || '')
        } finally {
          if (utf8Encoder) qrFactory.stringToBytes = previousStringToBytes
        }
      } catch (e) {
        this.logBridgeFailure('create-local-qr', e)
        return ''
      }
    },

    bindQrImageFallback: function () {
      var image = document.getElementById('payment-qr-image')
      if (!image || typeof image.addEventListener !== 'function') return
      image.addEventListener('error', function () {
        var fallbackUrl = String(image.getAttribute('data-fallback-src') || '')
        if (!fallbackUrl || image.getAttribute('data-fallback-used') === '1') return
        image.setAttribute('data-fallback-used', '1')
        image.src = fallbackUrl
      })
    },

    renderJsapi: function (payload) {
      var jsapiParams = payload.jsapiParams || {}
      var payNo = payload.payNo || ''
      var orderId = payload.orderId || payNo
      var amount = payload.amount || '--'
      var subject = payload.subject || ''
      var returnUrl = payload.returnUrl || 'https://www.nicara.ai'
      var statusQueryUrl = payload.statusQueryUrl || ''

      if (!jsapiParams.appId || !jsapiParams.paySign) {
        this.renderError(this.t('invalidJsapi'))
        return
      }

      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: this.t('wechatJsapiTitle'),
        channel: 'wechat',
        bodyHtml:
          this.renderOrderSummary(orderId, amount, subject) +
          '<div class="status-box">' +
          '<div class="hint">' + this.escapeHtml(this.t('wechatJsapiHint')) + '</div>' +
          '</div>' +
          '<div class="actions">' +
          '<button type="button" id="wechat-jsapi-pay" class="btn btn--wechat btn-jsapi">' +
          this.escapeHtml(this.t('wechatJsapiBtn')) + '</button>' +
          '</div>' +
          '<div id="pay-status" class="hint"></div>'
      })

      var self = this
      var btn = document.getElementById('wechat-jsapi-pay')
      if (btn) {
        btn.addEventListener('click', function () {
          self.invokeWechatJsapi(jsapiParams)
        })
      }

      if (this.isWechatBrowser()) {
        setTimeout(function () {
          self.invokeWechatJsapi(jsapiParams)
        }, 500)
      }

      if (statusQueryUrl) {
        this.startPolling(statusQueryUrl, returnUrl)
      }
    },

    invokeWechatJsapi: function (params) {
      var self = this
      var statusEl = document.getElementById('pay-status')

      function onBridgeReady () {
        window.WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: params.appId,
            timeStamp: params.timeStamp,
            nonceStr: params.nonceStr,
            package: params.package,
            signType: params.signType || 'RSA',
            paySign: params.paySign
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              if (statusEl) statusEl.textContent = self.t('paymentConfirmed')
            } else if (statusEl) {
              statusEl.textContent = self.t('wechatJsapiFail')
            }
          }
        )
      }

      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
        }
      } else {
        onBridgeReady()
      }
    },

    renderRedirect: function (payload) {
      var payUrl = payload.payUrl || ''
      var payNo = payload.payNo || ''
      var amount = payload.amount || '--'
      var subject = payload.subject || ''
      var channel = this.resolvePayChannel(payload)
      var returnUrl = payload.returnUrl || ''
      var handoffMode = this.getZapryHandoffMode()

      if (!payUrl) {
        this.renderError(this.t('invalidRedirect'))
        return
      }

      if (this.shouldRenderZapryExternalBrowserHandoff(payload) &&
        handoffMode !== 'external' &&
        (handoffMode !== 'inapp' || this.requiresExternalBrowserPayment(payload))) {
        var zapryPayUrl = String(window.location.href || '')
        var fallbackPayUrl = this.resolveRedirectPayUrl(payload)
        var self = this
        var zapryRoot = document.getElementById('allinpay-root')
        if (!zapryRoot) return
        zapryRoot.innerHTML = this.wrapCheckoutCard({
          activeStep: 3,
          title: channel === 'alipay' ? this.t('alipayTitle') : this.t('redirectTitle'),
          channel: channel,
          bodyHtml:
            this.renderOrderSummary(payNo, amount, subject) +
            this.renderZapryCallout(zapryPayUrl)
        })
        this.bindZapryControls(zapryPayUrl, payload, function () {
          self.replaceLocation(fallbackPayUrl)
          return true
        })
        return
      }

      var autoRedirect = this.shouldAutoRedirect(payload)
      this.persistRedirectReturnUrl(payload)
      this.persistRedirectBridgeUrl(payload)
      var redirectPayUrl = this.resolveRedirectPayUrl(payload)
      var statusHtml = autoRedirect
        ? '<div class="spinner brand-spinner brand-spinner--' + channel + '"></div>' +
          '<div class="hint">' + this.escapeHtml(this.t('redirectHint')) + '</div>'
        : '<div class="hint">' + this.escapeHtml(this.t('redirectReturnHint')) + '</div>'
      var actionsHtml =
        '<a class="btn btn--' + channel + '" href="' + this.escapeAttr(redirectPayUrl) + '">' + this.escapeHtml(this.t('continuePayment')) + '</a>'
      if (returnUrl) {
        actionsHtml += '<a class="btn btn-secondary" href="' + this.escapeAttr(returnUrl) + '">' + this.escapeHtml(this.t('returnMain')) + '</a>'
      }

      var root = document.getElementById('allinpay-root')
      if (!root) return
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: this.t('redirectTitle'),
        channel: channel,
        bodyHtml:
          this.renderOrderSummary(payNo, amount, subject) +
          '<div class="status-box">' +
          statusHtml +
          '</div>' +
          '<div class="actions">' +
          actionsHtml +
          '</div>'
      })

      if (!autoRedirect) {
        return
      }
      this.markRedirectAttempted(payload)
      setTimeout(function () {
        window.location.href = redirectPayUrl
      }, 1200)
    },

    startPolling: function (statusUrl, returnUrl) {
      var self = this
      var redirecting = false
      var statusEl = document.getElementById('pay-status')
      var lastPollAt = 0

      function updateStatus (text) {
        if (statusEl) statusEl.textContent = text
      }

      function poll () {
        var now = Date.now()
        if (now - lastPollAt < 800) return
        lastPollAt = now
        fetch(statusUrl, { credentials: 'omit', cache: 'no-store' })
          .then(function (resp) { return resp.json() })
          .then(function (json) {
            var data = (json && json.data) ? json.data : json
            if (!data) return
            if (data.paid) {
              if (redirecting) return
              redirecting = true
              updateStatus(self.t('paymentConfirmed'))
              setTimeout(function () {
                window.location.href = returnUrl || 'https://www.nicara.ai'
              }, 800)
              return
            }
            if (data.gatewayTradeStatus) {
              updateStatus(self.t('waitingConfirm') + ' (' + data.gatewayTradeStatus + ')')
            }
          })
          .catch(function () {
            updateStatus(self.t('waitingConfirm'))
          })
      }

      poll()
      setInterval(poll, 3000)
      if (document && typeof document.addEventListener === 'function') {
        document.addEventListener('visibilitychange', function () {
          if (!document.visibilityState || document.visibilityState === 'visible') poll()
        })
      }
      if (window && typeof window.addEventListener === 'function') {
        window.addEventListener('pageshow', poll)
      }
    },

    init: function () {
      var token = this.getBridgeToken()
      if (token) {
        var self = this
        this.renderSkeleton()
        return this.loadBridgeContext(token)
          .then(function (context) { self.renderForeignCardContext(context) })
          .catch(function (error) {
            self.logBridgeFailure('load-context', error)
            self.renderError(self.t('invalidPayload'))
          })
      }
      var payload = this.decodePayload()
      if (!payload) {
        this.renderError(this.t('invalidPayload'))
        return
      }

      var mode = (payload.allinpayCnpPayMode || '').toUpperCase()
      this.logBridgeDebugState(payload)

      if (mode === 'FORM_POST') {
        this.renderFormPost(payload)
        return
      }
      if (mode === 'QR_CODE') {
        this.renderQrCode(payload)
        return
      }
      if (mode === 'JSAPI') {
        this.renderJsapi(payload)
        return
      }
      if (mode === 'REDIRECT') {
        this.renderRedirect(payload)
        return
      }

      if (payload.action) {
        this.renderFormPost({
          allinpayCnpPayMode: 'FORM_POST',
          payChannel: 'alipay',
          payFormAction: payload.action,
          payFormCharset: payload._input_charset || 'UTF-8',
          payFormFields: this.extractFormFields(payload)
        })
        return
      }

      this.renderError(this.t('unsupportedMode'))
    },

    handleResult: function () {
      var params = new URLSearchParams(window.location.search)
      var returnTo = this.resolveResultReturnUrl(params.get('returnTo'))
      var cnpParams = ['resultCode', 'resultDesc', 'mchtId', 'accessOrderId', 'orderId', 'cardNo', 'cardOrgn']
      var targetUrl = new URL(returnTo)
      for (var i = 0; i < cnpParams.length; i++) {
        var val = params.get(cnpParams[i])
        if (val) {
          targetUrl.searchParams.append(cnpParams[i], val)
        }
      }
      window.location.href = targetUrl.toString()
    },

    renderBridgeReturnFallback: function (payNo) {
      var root = document.getElementById('allinpay-root')
      if (!root) return
      var bridgeUrl = this.resolveStoredRedirectBridgeUrl({ payNo: payNo })
      var actionsHtml =
        '<button type="button" id="bridge-return-retry" class="btn btn--wechat">' +
        this.escapeHtml(this.t('retryReturn')) + '</button>'
      if (bridgeUrl) {
        actionsHtml += '<a class="btn btn--wechat" href="' + this.escapeAttr(bridgeUrl) + '">' +
          this.escapeHtml(this.t('continuePayment')) + '</a>'
      }
      actionsHtml += '<a class="btn btn-secondary" href="https://shop.nicara.ai">' +
        this.escapeHtml(this.t('returnMain')) + '</a>'
      root.innerHTML = this.wrapCheckoutCard({
        activeStep: 3,
        title: this.t('returnFallbackTitle'),
        channel: 'wechat',
        bodyHtml:
          '<div class="hint">' + this.escapeHtml(this.t('returnFallbackHint')) + '</div>' +
          '<div class="actions">' + actionsHtml + '</div>' +
          '<div id="bridge-return-feedback" class="hint"></div>'
      })

      var self = this
      var retry = document.getElementById('bridge-return-retry')
      var feedback = document.getElementById('bridge-return-feedback')
      if (!retry) return
      retry.addEventListener('click', function () {
        if (retry.disabled) return
        retry.disabled = true
        if (feedback) feedback.textContent = self.t('waitingConfirm')
        self.resolveRemoteBridgeReturnUrl({ payNo: payNo })
          .then(function (targetUrl) {
            if (targetUrl) {
              self.replaceLocation(targetUrl)
              return
            }
            if (feedback) feedback.textContent = self.t('returnFallbackHint')
            retry.disabled = false
          })
      })
    },

    handleBridgeReturn: function () {
      var params = new URLSearchParams(window.location.search)
      var payNo = params.get('payNo') || ''
      var storedTargetUrl = this.resolveStoredRedirectReturnUrl({ payNo: payNo })
      if (storedTargetUrl && !this.isMainSiteUrl(storedTargetUrl)) {
        this.replaceLocation(storedTargetUrl)
        return
      }
      var self = this
      this.resolveRemoteBridgeReturnUrl({ payNo: payNo })
        .then(function (targetUrl) {
          if (targetUrl) {
            self.replaceLocation(targetUrl)
            return
          }
          self.renderBridgeReturnFallback(payNo)
        })
    },

    extractFormFields: function (payload) {
      var skipKeys = { action: true, method: true, _input_charset: true, allinpayCnpPayMode: true }
      var fields = {}
      for (var key in payload) {
        if (payload.hasOwnProperty(key) && !skipKeys[key]) {
          fields[key] = payload[key]
        }
      }
      return fields
    },

    escapeHtml: function (str) {
      var div = document.createElement('div')
      div.appendChild(document.createTextNode(str))
      return div.innerHTML
    },

    escapeAttr: function (str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
    }
  }

  function bootAllinpayBridge () {
    if (window.__ALLINPAY_BRIDGE_BOOTED) {
      return true
    }
    if (!document.getElementById('allinpay-root')) {
      return false
    }
    window.__ALLINPAY_BRIDGE_BOOTED = true
    var path = String(window.location.pathname || '')
    if (path.indexOf('allinpay-result') !== -1) {
      AllinpayBridge.handleResult()
    } else if (path.indexOf('allinpay-bridge-return') !== -1) {
      AllinpayBridge.handleBridgeReturn()
    } else {
      AllinpayBridge.init()
    }
    return true
  }

  function scheduleAllinpayBridgeBoot () {
    if (bootAllinpayBridge()) {
      return
    }
    var tries = 0
    var timer = setInterval(function () {
      tries += 1
      if (bootAllinpayBridge() || tries >= 50) {
        clearInterval(timer)
      }
    }, 100)
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = AllinpayBridge
  } else {
    window.AllinpayBridge = AllinpayBridge
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleAllinpayBridgeBoot)
    } else {
      scheduleAllinpayBridgeBoot()
    }
  }
})()
